import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 48px 20px;\n  @media (max-width: 768px) {\n    max-width: 390px;\n    padding: 24px 16px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { styled } from "@mui/material";
import { OrderSection, OrderStack } from "../../Books/Order/BooksOrder";
import { ConfirmDialog } from "@bookips/solvook-ui-library";
import { OrderTitle } from "../../Books/Order";
import { PaymentCard } from "./PaymentCard";
import { ProductCard } from "./ProductCard";
import { numberFormatter } from "@/lib/utils";
import { LoginDialogProvider } from "@/components/common/LoginDialogProvider";
import { DetailInfoButton } from "./DetailInfoButton";
export const OrderLayout = (param)=>{
    let { PageTitle , productInfo , infoDialog , successDialog , errorCode , errorMessages , handleChange , handleSubmit , payMethod  } = param;
    return /*#__PURE__*/ _jsx(LoginDialogProvider, {
        children: /*#__PURE__*/ _jsxs(LayoutContainer, {
            children: [
                /*#__PURE__*/ _jsxs(ContentsWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(OrderTitle, {
                            primary: PageTitle
                        }),
                        /*#__PURE__*/ _jsx(OrderContainer, {
                            children: /*#__PURE__*/ _jsxs(OrderStack, {
                                children: [
                                    /*#__PURE__*/ _jsx(OrderSection, {
                                        label: "상품 정보",
                                        children: /*#__PURE__*/ _jsx(ProductCard, {
                                            price: numberFormatter(productInfo.price),
                                            title: productInfo.title
                                        })
                                    }),
                                    infoDialog && /*#__PURE__*/ _jsx(DetailInfoButton, {
                                        infoDialog: infoDialog,
                                        productInfo: productInfo
                                    }),
                                    /*#__PURE__*/ _jsx(OrderSection, {
                                        label: "결제 정보",
                                        children: /*#__PURE__*/ _jsx(PaymentCard, {
                                            handleChange: handleChange,
                                            handleSubmit: handleSubmit,
                                            payMethod: payMethod,
                                            productInfo: productInfo,
                                            terms: productInfo === null || productInfo === void 0 ? void 0 : productInfo.description
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                errorCode !== 200 && /*#__PURE__*/ _jsx(ConfirmDialog, {
                    open: true,
                    ...errorMessages[errorCode]
                }),
                infoDialog && {
                    ...infoDialog.infoDialogProps
                }
            ]
        })
    });
};
export const LayoutContainer = styled("div")((param)=>{
    let { theme  } = param;
    return {
        flexGrow: 1,
        backgroundColor: theme.palette.grey[0]
    };
});
export const ContentsWrapper = styled("article")(_templateObject());
const OrderContainer = styled("div")(_templateObject1());
